// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { sync } from 'vuex-router-sync'
import vuexI18n from 'vuex-i18n'
import store from './store'
import VueFire from 'vuefire'
import VueBarcode from 'vue-barcode'
// import './firebase'
import {db, usersRef} from './firebase'
import Firebase from 'firebase'
import translationsEn from './i18n/en.json'
import translationsFr from './i18n/fr.json'
import Vue2Leaflet from 'vue2-leaflet'
import VuePaginate from 'vue-paginate'
import VueHtmlToPaper from 'vue-html-to-paper'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
// import ToggleSwitch from 'vuejs-toggle-switch'
import Geocoder from '@pderas/vue2-geocoder'
// import {mixin as clickaway} from 'vue-clickaway'
import VScrollLock from 'v-scroll-lock'
import RegularInput from './components/module/basic-components/RegularInput.vue'

export const AWS = require('aws-sdk')
AWS.config.update({
  accessKeyId: 'AKIAJ5ABFYKYST5YM7DA', secretAccessKey: '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', region: 'us-east-1'
})

window._ = require('lodash')
window.axios = require('axios')
Vue.config.productionTip = false

var userLang = navigator.language || navigator.userLanguage || 'en'
Vue.component('general-announcement', require('./components/module/special-components/Other-components/general-announcement.vue'))
Vue.component('NavBar', require('./components/module/interface-components/NavBar.vue').default)
Vue.component('regularDatalist', require('./components/module/basic-components/regularDatalist.vue').default)
Vue.component('regularFilter', require('./components/module/basic-components/regularFilter.vue').default)
Vue.component('v-map', Vue2Leaflet.Map)
Vue.component('v-tilelayer', Vue2Leaflet.TileLayer)
Vue.component('v-marker', Vue2Leaflet.Marker)
Vue.component('v-circle', Vue2Leaflet.LCircle)
Vue.component('v-popup', Vue2Leaflet.Popup)
Vue.component('google-map', VueGoogleMaps)
Vue.component('GmapCluster', GmapCluster)
Vue.component('barcode', VueBarcode)
Vue.component('RegularInput', RegularInput)

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VuePaginate)
Vue.use(VScrollLock)
Vue.use(VueHtmlToPaper, options)
/* Vue.component('', VueGoogleMaps, {
  load: {
    key: 'AIzaSyDKYyoAdkuKtDyajGZ8K4NBA1KgwJMljj4',
    libraries: 'places' // necessary for places input
  },
  installComponents: true
}) */
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDKYyoAdkuKtDyajGZ8K4NBA1KgwJMljj4',
    libraries: 'places'
  },
  installComponents: true
})

Vue.use(Geocoder, {
  defaultCountryCode: null,
  defaultLanguage: null,
  defaultMode: 'address',
  googleMapsApiKey: 'AIzaSyDKYyoAdkuKtDyajGZ8K4NBA1KgwJMljj4'
})
Vue.use(vuexI18n.plugin, store)
Vue.use(VueFire)
Vue.use(Autocomplete)
// Vue.use(ToggleSwitch)
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('fr', translationsFr)
userLang.slice(0, 2) === 'fr' || userLang.slice(0, 2) === 'en' ? Vue.i18n.set(userLang.slice(0, 2)) : Vue.i18n.set('en')
sync(store, router)
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Firebase.auth().currentUser) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

Vue.mixin({
  data () {
    return {
      isScreenSmall: false,
      isChatOpen: false
    }
  },
  // mixins: [ clickaway ],
  methods: {
    /** @param firebasepath : Path to the Firebase ref
     *  @param updatedDataName : Property that is being set
     *  @param updatedDataValue : Value that will be set to the property
     */
    setFirebaseData (firebasePath, updatedDataName, updatedDataValue) {
      firebasePath.child(updatedDataName).set(updatedDataValue).then(() => {
      }).catch((error) => {
        console.log('Error found in setting firebase data', error)
      })
    },

    updateFirebaseData (firebasePath, updatedDataObj) {
      firebasePath.update(updatedDataObj).then(() => {
        console.log('Update completed')
      }).catch((error) => {
        console.log('Error found in updating firebase data', error)
      })
    },

    async toggleChat () {
      this.isChatOpen = !this.isChatOpen
        await usersRef.doc(this.uid)
        .update({hasNewMessage: false})
    },

    /** Checks if overload is undefined (If it exists or not)
     * @param data: Anything
    */
    checkIsUndefined (data) {
      return (typeof data === 'undefined')
    }

    // clickAwaySidebar () {
    //   if (this.$refs.modalJS.checkIsModalOpened) {
    //     this.$refs.toggleSidebarArrow.toggleSidebar()
    //     return
    //   }
    //   // let modalState = this.$refs.modalJS.checkIsModalOpened()
    //   this.$refs.toggleSidebarArrow.openSidebar()
    // }
  },
  computed: {
    // COMMENT ON PROD
    // isBrunoAccount () {
    //   return true
    // }
    // [DEV] UNCOMMENT ON PROD
    isBrunoAccount () {
      return (this.$store.state.authorization.company === 'e58ff614-8449-4c3e-90b8-b42a48c2972b')
    }
  }
})

const unsubscribe = Firebase.auth().onAuthStateChanged(async (user) => {
  store.commit('setUser', user || false)
  if (user !== null) {
    let authorize

    // Set Authorization
    await db.ref('users/transportersman').child(user.uid).once('value').then((snapshot) => {
      snapshot.val() === null ? authorize = false : authorize = true; store.commit('setAuthorization', snapshot.val())
    })
    if (!authorize) {
      Firebase.auth().signOut().then(() => {
        store.commit('clearUser')
        store.commit('clearContacts')
      }).catch(() => {})
      return router.push({path: '/login'})
    }

    // Check if an already connected user has created a username for the chat system, if not send them back to /login
    await usersRef.doc(user.uid)
    .get()
    .then(querySnapshot => {
      if (!querySnapshot.exists) {
        // doc.data() will be undefined in this case
        console.log('No such document!')
        Firebase.auth().signOut().then(() => {
          store.commit('clearUser')
          store.commit('clearContacts')
        }).catch(() => {})
        return router.push({path: '/login'})
      }
    })

    /** Check if a user has unseen messages and set a listener for new messages
    If the user has unseen messages in Firestore, set @param store.state.hasNewMessage variable to true */
    usersRef.doc(user.uid)
      .onSnapshot(querySnapshot => {
        if (querySnapshot.exists) {
          if (querySnapshot.data().hasNewMessage === true) {
            store.state.hasNewMessage = true
          } else {
            store.state.hasNewMessage = false
          }
        }
      })

    // Set UserInfo
    await db.ref('users/transporters').child(store.state.authorization.company).once('value').then((snapshot) => {
      store.commit('setUserInfo', snapshot.val() || false)
      if (snapshot.val().language === undefined || snapshot.val().language === '') {
        console.log('LANGUAGE NOT FOUND')
        Vue.i18n.set('en')
      } else Vue.i18n.set(snapshot.val().language)
      if (!snapshot.val().isSageOne) store.commit('initAllContact')
    })
    // if (user.uid !== 'e58ff614-8449-4c3e-90b8-b42a48c2972b') store.commit('initAllContact')
  }
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
  unsubscribe()
})
